import { StructuredJsonFieldDef } from '../../shared/design-system/structured-json-form.model';

export const INSURANCE_COMMISSION_BASIS_OPTIONS: Array<{ value: string; labelKey: string }> = [
  { value: 'PercentOfPremium', labelKey: 'insurance.commissions.basis.percentOfPremium' },
  { value: 'Fixed', labelKey: 'insurance.commissions.basis.fixed' },
  { value: 'Tiered', labelKey: 'insurance.commissions.basis.tiered' }
];

export interface CommissionTierRule {
  upTo: number | null;
  percent: number;
}

export function commissionBasisLabelKey(basis: string): string {
  const match = INSURANCE_COMMISSION_BASIS_OPTIONS.find(item => item.value === basis);
  return match?.labelKey ?? 'insurance.commissions.basis.percentOfPremium';
}

export function getCommissionPlanRulesFields(basis: string): StructuredJsonFieldDef[] {
  if (basis === 'Fixed') {
    return [
      {
        key: 'amount',
        type: 'number',
        labelKey: 'insurance.commissions.planDetail.rules.fields.amount',
        required: true
      }
    ];
  }

  if (basis === 'Tiered') {
    return [];
  }

  return [
    {
      key: 'percent',
      type: 'number',
      labelKey: 'insurance.commissions.planDetail.rules.fields.percent',
      required: true
    }
  ];
}

export function defaultCommissionRulesJson(basis: string): string {
  if (basis === 'Fixed') {
    return '{"amount":0}';
  }
  if (basis === 'Tiered') {
    return '{"tiers":[]}';
  }
  return '{"percent":10}';
}

export function parseCommissionTiers(rulesJson: string): CommissionTierRule[] {
  try {
    const parsed = JSON.parse(rulesJson || '{}') as { tiers?: unknown };
    if (!Array.isArray(parsed.tiers)) {
      return [];
    }

    return parsed.tiers
      .map(item => {
        if (!item || typeof item !== 'object') {
          return null;
        }
        const row = item as Record<string, unknown>;
        const percent = Number(row['percent']);
        if (Number.isNaN(percent)) {
          return null;
        }
        const upToRaw = row['upTo'];
        const upTo = upToRaw === null || upToRaw === undefined || upToRaw === ''
          ? null
          : Number(upToRaw);
        return {
          upTo: upTo !== null && Number.isNaN(upTo) ? null : upTo,
          percent
        };
      })
      .filter((item): item is CommissionTierRule => item !== null);
  } catch {
    return [];
  }
}

export function serializeCommissionTiers(tiers: CommissionTierRule[]): string {
  return JSON.stringify({
    tiers: tiers.map(tier => ({
      ...(tier.upTo !== null && tier.upTo !== undefined ? { upTo: tier.upTo } : {}),
      percent: tier.percent
    }))
  });
}
